import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	Layout,
	Text,
	TextAlignment,
	TokenTextAppearance,
	styled,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { useSelector } from 'react-redux';
import {
	ConfirmacionWrapper,
	LastNavigation,
	LegalesFormatoLayer,
	PoliticaPrivacidad,
} from 'src/components';
import icon from 'src/components/img/icon-star-white.svg';
import { OneFormState } from 'src/types';

const PoliticaWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
`;

interface ConfirmacionEnvioProps {
	title?: JSX.Element;
}

export const ConfirmacionEnvio = (props: ConfirmacionEnvioProps) => {
	const { formInfo } = useSelector((state: OneFormState) => state);
	const isLayer = formInfo?.formType === 'layer' || !formInfo?.notALayer;
	const { title } = props;

	return (
		<ConfirmacionWrapper>
			<Layout
				appearance={{
					[Breakpoints.default]: [
						{ name: '.', columns: 2 },
						{ name: 'a', columns: 20 },
						{ name: '.', columns: 2 },
					],
					[Breakpoints.b960]: [
						{ name: '.', columns: 3 },
						{ name: 'a', columns: 18 },
						{ name: '.', columns: 3 },
					],
				}}
			>
				<Container
					wrap={'always'}
					horizontalAlign={'center'}
					gutter={ContainerGutter.static300}
				>
					<div style={{ textAlign: 'center', width: '100%' }}>
						<img src={icon} alt="icon" />
					</div>
					<Text
						textAlign={TextAlignment.center}
						appearance={TokenTextAppearance.headline300}
					>
						{title ? (
							title
						) : (
							<>
								<Text bold>¿Listo </Text>para enviar?
							</>
						)}
					</Text>
					<PoliticaWrapper>
						<PoliticaPrivacidad />
					</PoliticaWrapper>
				</Container>
				<LastNavigation loadingCopy="Enviando tu petición" />
				{isLayer && (
					<Container
						padding={{
							top: ContainerPadding.static550,
							bottom: ContainerPadding.static515,
						}}
						gutter={ContainerGutter.static300}
						wrap={'always'}
					>
						<Text
							bold
							staticSize
							appearance={TokenTextAppearance.copy200}
						>
							Texto legal de Volkswagen
						</Text>
						<LegalesFormatoLayer noPadding={true} />
					</Container>
				)}
			</Layout>
		</ConfirmacionWrapper>
	);
};
